<template>
<div>
    <vue-element-loading :active="isLoading" is-full-screen text="Please wait..." />
    <component :is="this.headerFooter.header"></component>
    <div class="tool-bar">
        <div class="tool-form">
            <div class="row">
                <div class="col-5">
                    <input class="form-control cr-input" type="text" v-model="searchTxt" :placeholder="$t('account_or_password')" style="width: 200px;"/>
                </div>
                <div class="col-3">
                    <button type="button" class="btn btn-secondary" @click="searchClinet" style="margin-top:10px;margin-left:20px;width: 100px;">{{$t("search")}}</button>
                </div> 
                <div class="col-4">
                    <button type="button" class="btn btn-secondary" @click="showAllClient" style="margin-top:10px;width: 100px;">{{$t("all_client")}}</button>
                </div> 
            </div>
        </div>
    </div>
    <table class="table table-hover" id="_appendHere" style="text-align:center;">
        <thead>
        <tr>
            <th scope="col" style="text-align:center;"></th>
            <th scope="col" style="text-align:center;">{{$t("name")}}</th>
            <th scope="col" style="text-align:center;">{{$t("account")}}</th>
            <th scope="col" style="text-align:center;">{{$t("blood_pressure")}}</th>
            <th scope="col" style="text-align:center;">{{$t("heart_rate")}}</th>
            <th scope="col" style="text-align:center;">
                {{$t("measurement_time")}}
                <span class="order" :class="classOrderCheck('testTime', pageCtl)" @click="orderSet($event.target, 'testTime', pageCtl)"></span>
            </th>
            <th scope="col" style="text-align:center;">{{$t("consultant")}}</th>
            <th scope="col" style="text-align:center;">{{$t("measurement_report")}}</th>
        </tr>
        </thead>
        <tbody>
            <tr v-for="(item, index) in clientList" :key="index">
                <td style="vertical-align:middle;">
                    <img :src="(item.user_img_url) ? item.user_img_url : userDefaultImg" width="50px" height="50px">
                </td>
                <td style="vertical-align:middle;">
                    {{item.user_name}}
                </td>
                <td style="vertical-align:middle;">
                    {{item.client}}
                </td>
                <td style="vertical-align:middle;">
                    <span :class="{'red_b': checkAberrantBpData('hbp', item.systolic_bp)}">{{ item.systolic_bp }}</span>
                    <span> / </span>
                    <span :class="{'red_b': checkAberrantBpData('lbp', item.diastolic_bp)}">{{item.diastolic_bp}}</span>
                </td>
                <td style="vertical-align:middle;">
                    <span :class="{'red_b': checkAberrantBpData('hb', item.heartbeat)}">{{ item.heartbeat }}</span>
                </td>
                <td style="vertical-align:middle;">
                    {{item.datetime}}
                </td>
                <td style="vertical-align:middle;">
                    {{item.docName}}
                </td>
                <td style="vertical-align:middle;"><button type="button" class="btn btn-secondary" @click="gotoClientReport(item.client,item.docName)">{{$t("report_list")}}</button></td>
                <!-- <td style="vertical-align:middle;"><button type="button" class="btn btn-secondary">中醫脈型分類</button></td> -->
            </tr>
        </tbody>
    </table>
    <div class="overflow-auto">
        <div>
        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" @click.native="getCurrentPage(currentPage)" align="center"></b-pagination>
        </div>
    </div>
</div>
</template>
<script>
import { checkAberrantBpData } from '@/js/checkBpData'
import Header from '@/components/Header.vue';
import store from "@/store"
export default {
    data() {
        return {
            searchTxt: '',
            doc_account: 'cherng0125',
            setPage: 0,
            totlePage: 0,
            currentPage: 1,
            perPage: 20,
            clientList: [],
            userDefaultImg: 'https://hxesther-bucket.oss-cn-hangzhou.aliyuncs.com/hxesther/imgs/user2.png',
            isLoading: false,
            pageCtl: {
                length:9,
                max: 1,
                order:'testTime',
                desc:true,
            },
        }
    },
    components: {
        Header,
    },
    created(){
        const user = JSON.parse(sessionStorage.getItem('my_info'));
        if(user === null){
            alert("请重新登入");
            this.$router.push('/login');
        }else{
            this.getClinetInfo();
        }
        // this.doc_account = user[0].account;
        
    },
    computed: {
        headerFooter() {
            return store.getters['auth/isLoggedIn'] ? {
                header: Header,
            } : {
                header: Header,
            }
        },
        rows() {
            return this.totlePage
        },
    },
    methods: {
        getClinetInfo() {
            this.isLoading = true;
            const api = `${process.env.VUE_APP_APIPATH}/client/list`;
            const json = {
                doc_account: this.doc_account,
                setPage: this.setPage,
                limit: 20,
                setDesc: this.pageCtl.desc
            }
            this.$http.post(api, json).then((res) => {
                this.searchTxt = '';
                const status = res.data.Status;
                if(status === 'success'){
                    const jsonData = JSON.parse(res.data.data);
                    this.clientList = jsonData;
                    this.getAllClientCount();
                }
            })
        },
        getAllClientCount() {
            const api = `${process.env.VUE_APP_APIPATH}/client/count`;
            const json = {
                doc_account: this.doc_account,
            }
            this.$http.post(api, json).then((res) => {
                const status = res.data.Status;
                if(status === 'success'){
                    this.totlePage = res.data.data[0].count-120;
                }
                this.isLoading = false;
            })
        },
        searchClinet() {
            if(this.searchTxt !== ''){
                this.isLoading = true;
                const api = `${process.env.VUE_APP_APIPATH}/search/client/list`;
                const json = {
                    doc_account: this.doc_account,
                    search: this.searchTxt
                }
                this.$http.post(api, json).then((res) => {
                    const status = res.data.Status;
                    if(status === 'success'){
                        if(res.data.data !== '[]'){
                            const jsonData = JSON.parse(res.data.data)
                            this.clientList = jsonData;
                            this.totlePage = 1;
                        }else{
                            alert(this.$t("no_client"));
                        }
                    }else{
                        alert(this.$t("no_client"));
                    }
                    this.isLoading = false;
                })
            }
        },
        showAllClient() {
            this.setPage = 0;
            this.currentPage = 0;
            this.getClinetInfo();
        },
        getCurrentPage(currentPage) {
            if(currentPage == 1) {
                this.setPage = 0;
            }else {
                this.setPage = 20 * (currentPage - 1);
            }
            this.getClinetInfo();
            window.document.body.scrollTop = 0;
            window.document.documentElement.scrollTop = 0;
        },
        gotoClientReport(clientAccount,docName) {
            this.$router.push({path: '/reportlist', query: { clientAccount: clientAccount, clientDoc: docName}});
        },
        classOrderCheck(name, pageCtl){
            if( pageCtl.order == name ){
                return ( this.pageCtl.desc ) ? 'down' : 'up';
            }else{
                return 'up';
            }
        },
        orderSet(e, name, pageCtl){
            var className = e.className;

            var orders = document.querySelectorAll('.order');
            for( var i=0; i<orders.length; i++ ){
                if( orders[i].classList.contains('down') ){
                    orders[i].classList.remove('down');
                    orders[i].classList.add('up');
                }
            }
            e.className = className;
            e.classList.toggle('up');
            e.classList.toggle('down');

            e.classList.contains('up') ? pageCtl.desc = false : pageCtl.desc = true;

            this.pageCtl.desc = pageCtl.desc
            this.pageCtl.order = name;

            this.getClinetInfo();
        },
        checkAberrantBpData: checkAberrantBpData,
    }
}
</script>